import React from 'react'

const TitleTwo = (props) => {
  return (
    <div className='font-semibold text-2xl text-center border-b-[3px] pb-1 border-Pink  w-fit mx-auto px-5 mb-5 '>{props.title}</div>
  )
}

export default TitleTwo